export default function getScript(source, asyncLoad = true, defer = false) {
    return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${source}"]`)) {
            return resolve() // Script already loaded
        }

        const script = document.createElement('script')
        const prior = document.getElementsByTagName('script')[0]
        script.async = asyncLoad
        script.defer = defer
        script.addEventListener('load', () => resolve())
        script.addEventListener('error', () => reject(new Error('Loading script')))
        script.src = source
        prior.parentNode.insertBefore(script, prior)
    })
}
